import { render, staticRenderFns } from "./HomeOnboarding.vue?vue&type=template&id=c4043710"
import script from "./HomeOnboarding.vue?vue&type=script&lang=js"
export * from "./HomeOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports